module.exports = __webpack_public_path__ + "static/nodata@2x.4091b55b.png";